import React from 'react';
import CalculusOfHarm from '../components/CalculusOfHarm';

function CalculusOfHarmPage() {
  return <CalculusOfHarm />;
}

export default CalculusOfHarmPage;
